import React, { useEffect } from 'react';

import { ItemAddedToCartV1, PdpPageEvents } from '@vp/pdp-events';
import { Link } from '@vp/swan';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { ToastProvider } from '../components/StickyToast';

export const useItemAddedToCart: ToastProvider = (setToast) => {
  const { t } = useLocalizations();
  useEffect(() => {
    const handleItemAddedToCart = (event: ItemAddedToCartV1) => {
      const body = event.isSuccessful ? (
        <>
          {t('add-to-cart-success').replace('{0}', event.productName)}{' '}
          {event.goToCartLink && (
            <Link href={event.goToCartLink}>{t('add-to-cart-go-to-cart')}</Link>
          )}
        </>
      ) : (
        <>{t('generic-error')}</>
      );
      setToast({
        body,
        skin: event.isSuccessful ? 'positive' : 'error',
      });
    };

    return PdpPageEvents.listenToItemAddedToCartEventV1(handleItemAddedToCart);
  }, []);
};
